import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    clientSlug = 'demo';

    constructor() {
        let href = window.location.href;
        let pathname = window.location.pathname;
        if (href.startsWith("https")) {
            this.clientSlug = pathname.split("/")[1];
            console.log(this.clientSlug)
        }
    }

    setItem(itemName: string, value): void {
        localStorage.setItem('taskradar_' + this.clientSlug + '_' + itemName, JSON.stringify(value));
    }

    getItem(itemName: string): any {
        if (localStorage.getItem('taskradar_' + this.clientSlug + '_' + itemName)) {
            return JSON.parse(localStorage.getItem('taskradar_' + this.clientSlug + '_' + itemName));
        } else {
            return null;
        }
    }

    removeItem(itemName: string): void {
        localStorage.removeItem('taskradar_' + this.clientSlug + '_' + itemName);
    }
}
